/**
 * Key-order-insensitive stringify for dirty/reset compares. A plain
 * JSON.stringify compare re-arms Save right after a successful save when the
 * post-save refetch echo carries the same values in a different key order
 * (BUGS.md M17, portal builder, FIXED 2026-07-05 W2-E). Shared by the portal,
 * calendar and wallet builder dirty checks — use this instead of raw
 * JSON.stringify whenever one compare side can come back from the server.
 */
export function stableStringify(value: unknown): string {
  return JSON.stringify(value, (_key, v: unknown) =>
    v && typeof v === "object" && !Array.isArray(v)
      ? Object.fromEntries(
          Object.entries(v as Record<string, unknown>).sort(([a], [b]) =>
            a < b ? -1 : a > b ? 1 : 0,
          ),
        )
      : v,
  );
}
